import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { FormControl, NgForm, Validators } from "@angular/forms";
import Swal from "sweetalert2";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { Bank, BanksDetails } from "../user-profile-details/bank";
import { UrlConstants } from "src/app/models/urlConstants";
import { Account, ClientData } from "src/app/screens/user-profile/client-data";
import { RequestService } from "src/app/services/request.service";
import {
  BroadcastEventListener,
  ISignalRConnection,
  SignalR,
  SignalRConfiguration,
} from "ng2-signalr";
import { ApiService } from "src/app/services/api.service";
import { MatDialog } from "@angular/material/dialog";
import { SummaryModalComponent } from "../summary-modal/summary-modal.component";
import { Currency } from "../user-profile-details/currency";
import { SystemSettingsService } from "src/app/services/systemSettings.service";


enum OptionType {
  Cheque = "cheque",
  Bank = "bank",
  // Cash = "cash",
}

interface Option {
  id: OptionType;
  label: string;
  icon?: string;
  hoverIcon?: string;
}

@Component({
  selector: "app-request-withdraw-modal",
  templateUrl: "./request-withdraw-modal.component.html",
  styleUrls: ["./request-withdraw-modal.component.scss"],
})
export class RequestWithdrawModalComponent implements OnInit {
  selectedOption: OptionType = null;
  banksDetailsList: BanksDetails[] = [];
  options: Option[] = [];
  @Input() selectedAccount: Account;
  newWithdraw: any = {};
  isSubmitting = false;
  titleMessage: string;
  textConfirmMassage: string;
  today: string;
  currencyList: any[] = [];
  banksList: any[] = [];
  branches: any[] = [];
  submitStatus;
  userPortfolio: ClientData;
  userAccounts: Account[];
  balanceAmount: any;
  purchasePowerRes: any;
  private portfolioConnection: ISignalRConnection;
  lastExecutionTime: number;
  isProfileLoading: boolean;
  noChart: boolean | null;
  companyName: string;
  purchaseStocks: number;
  chartStocks: number;
  ratedActiveBalance: number;
  Endorsement: string;
  selectedCurrency: any;
  selectedBank: any;
  selectedBranch: any;
  hoveredOption: OptionType | null = null;
  accountList: Account[];
  allBanks: any[] = [];
  ChequeAvailability: boolean | null = null;

  @ViewChild("withdrawForm") withdrawForm: NgForm;
  selectedAccountControl = new FormControl(null, Validators.required);
  isIban: boolean;
  constructor(
    public translate: TranslateService,
    private http: HttpClient,
    private router: Router,
    private datepipe: DatePipe,
    private requestService: RequestService,
    private apiService: ApiService,
    private signalR: SignalR,
    private dialog: MatDialog,
    private settingsService: SystemSettingsService,
    
  ) {}

  ngOnInit(): void {
    const date = new Date();
    this.today = date.toISOString().split("T")[0]; // Formats to 'YYYY-MM-DD'
    this.newWithdraw = {
      Date: this.today,
    };
    this.accountList = JSON.parse(localStorage.getItem("accList"));
    this.selectedAccount = this.accountList[0];
    this.clientSelected(this.selectedAccount);
    this.fetchUserPortfolio(this.selectedAccount);
    this.fetchChequeAvailability();  
    // this.options = [
    //   {
    //     id: OptionType.Cheque,
    //     label: this.translate.instant("check-deposit"),
    //     icon: "cheque-signing",
    //     hoverIcon: "cheque-signingBW",
    //   },
    //   {
    //     id: OptionType.Bank,
    //     label: this.translate.instant("bank-transfer"),
    //     icon: "bank",
    //     hoverIcon: "bankBW",
    //   },
    //   // {
    //   //   id: OptionType.Cash,
    //   //   label: this.translate.instant("cash-withdraw"),
    //   //   icon: "Cash",
    //   //   hoverIcon: "CashBW",
    //   // },
    // ];
    this.requestService.fetchActiveCurrencies().subscribe((res) => {
      this.currencyList = res;
      this.selectedCurrency = this.currencyList[0];
    });
    
    this.getBanks();

    this.selectOption(OptionType.Cheque);
    this.onAccountChange(this.selectedAccount.relationCode);
  }

  getBanks(){
    this.requestService.fetchBanks().subscribe((res) => {
      const bankMap = new Map<number, any>();
      res.forEach(bank => {
        if (!bankMap.has(bank.BankID)) {
          bankMap.set(bank.BankID, bank);
        }
      });
      this.banksList = Array.from(bankMap.values()).filter(bank => bank.BankBranches && bank.BankBranches.length > 0);
      this.selectedBank = res[0];      
      this.allBanks = res.filter(bank => bank.BankBranches && bank.BankBranches.length > 0);
      this.GetBranches(this.selectedBank.BankID)
    }); 
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedAccount && changes.selectedAccount.currentValue) {
      this.clientSelected(changes.selectedAccount.currentValue);
      this.fetchUserPortfolio(changes.selectedAccount.currentValue);
    }
  }
  fetchChequeAvailability() {
    this.settingsService.checkSetting("enable-cheque-withdrawal").subscribe((arg) => {
      this.ChequeAvailability = arg;
      this.setOptions();
      this.setDefaultOption();
    });
  }
  setOptions() {
  if (this.ChequeAvailability === true) {
    this.options = [
      {
        id: OptionType.Cheque,
        label: this.translate.instant("check-deposit"),
        icon: "cheque-signing",
        hoverIcon: "cheque-signingBW",
      },
      {
        id: OptionType.Bank,
        label: this.translate.instant("bank-transfer"),
        icon: "bank",
        hoverIcon: "bankBW",
      }
    ];
  } else {
    this.options = [
      {
        id: OptionType.Bank,
        label: this.translate.instant("bank-transfer"),
        icon: "bank",
        hoverIcon: "bankBW",
      }
    ];
  }
}

  fetchPurchasePower() {
    this.apiService
      .fetchPurchasePower(this.selectedAccount.relationCode)
      .subscribe((arg) => {
        this.purchasePowerRes = arg;
        this.balanceAmount = this.purchasePowerRes.BlockingAmount;
      });
  }

  get availableWithdrawBalance() {
    if (
      this.balanceAmount &&
      this.withdrawForm?.form?.get("CurrencyId")?.value != null
    ) {
      var x = this.balanceAmount.find(
        (x) =>
          x.curr ==
          this.withdrawForm.form.get("CurrencyId").value["AbbreviationE"]
      );
      if (x) return x["AvailableBalanceForWithdrow"];
      else return 0;
    }
  }
  selectOption(optionId: OptionType) {
    this.selectedOption = optionId;
    this.hoveredOption = optionId;
    switch (optionId) {
      case OptionType.Cheque:
        this.newWithdraw.ActionType = 1;
        break;
      case OptionType.Bank:
        this.newWithdraw.ActionType = 2;
        break;
      // case OptionType.Cash:
      //   this.newWithdraw.ActionType = 3;
      //   break;
    }
  }
setDefaultOption() {

    // Otherwise select the first available option (Bank)
    this.selectOption(this.options[0].id);
  
}

  GetBranches(event: any) {
    const BankID  = event;
    this.branches = this.allBanks.filter(bank => bank.BankID === BankID)[0]?.BankBranches??[];
    this.selectedBranch = this.branches.length > 0 ? this.branches[0] : null;
    
  }

  // clientSelected(e: Account) {
  //   // this.apiService.fetchClientAccounts(e.relationCode).subscribe((res) => {
  //   //   this.userAccounts = res as Account[];
  //   //   this.initPortfolioSignalR();
  //   //   this.selectedAccountControl.setValue(null);
  //   // });
  //   this.userAccounts = JSON.parse(
  //     localStorage.getItem("accList")
  //   ) as Account[];
  //   this.initPortfolioSignalR();
  //   this.selectedAccountControl.setValue(null);
  // }
  clientSelected(e: Account) {
    this.selectedAccount = e;
    this.apiService.fetchClientAccounts(e.relationCode).subscribe((res) => {
      this.userAccounts = res as Account[];
      this.initPortfolioSignalR();
      this.onAccountChange(this.selectedAccount.relationCode);
      //this.selectedAccountControl.setValue(this.selectedAccount.relationCode);
      // this.selectedAccountControl.setValue(null);
    });
    this.fetchUserPortfolio(this.selectedAccount);
    this.onAccountChange(this.selectedAccount.relationCode);
  }
  fetchUserPortfolio(selectedAcc?) {
    if (selectedAcc) this.selectedAccount = selectedAcc;

    if (this.selectedAccount != null && this.selectedAccount.relationCode) {
      this.requestService
        .fetchUserPortfolio(this.selectedAccount.relationCode)
        .subscribe((res) => {
          this.userPortfolio = res as ClientData;
        });
    }
    // this.newWithdraw.Date = null;
    this.newWithdraw.Amount = null;
    this.newWithdraw.Note = null;
    this.newWithdraw.SwiftCode = null;
    this.newWithdraw.AccountNumber = null;
    this.selectedCurrency = this.currencyList[0];
  }

  onMouseOut(optionId: OptionType) {
    if (this.selectedOption !== optionId) {
      this.hoveredOption = null;
    }
  }

    onCurrencyChange(currency: Currency) {
  
    this.banksList.forEach((bank) => {
    });
  
    // First, filter by selected currency
    const filteredByCurrency = this.allBanks.filter(
      (bank) => Number(bank.CurrencyId) === Number(currency.CurrencyID)
    );
  
    // Then, remove duplicates based on BankID
    const uniqueBanksMap = new Map<number, any>(); // assuming BankID is a number
  
    filteredByCurrency.forEach((bank) => {
      if (!uniqueBanksMap.has(bank.BankID)) {
        uniqueBanksMap.set(bank.BankID, bank);
      }
    });
  
    this.banksList = Array.from(uniqueBanksMap.values());
  
  }
  processBanksList(banks: any[]): void {
    const bankMap = new Map<number, any>();
    banks.forEach(bank => {
      if (!bankMap.has(bank.BankID)) {
        bankMap.set(bank.BankID, bank);
      }
    });
    this.banksList = Array.from(bankMap.values());
    this.selectedBank = this.banksList[0];
    this.allBanks = banks;
  }


  onAccountChange(relationCode: string) {
    if (!this.accountList) {
      return;
    }

    const selectedAcc = this.accountList.find(
      (acc) => acc.relationCode === relationCode
    );
    if (selectedAcc) {
      this.selectedAccount = selectedAcc;
      this.fetchUserPortfolio(selectedAcc);
      this.initPortfolioSignalR();
      this.refetchClientInfo();
      this.fetchPurchasePower();
    }
  }

  initPortfolioSignalR() {
    if (this.portfolioConnection != null) this.portfolioConnection.stop();

    if (this.selectedAccount.ExchangeCode != null) {
      let config: SignalRConfiguration = new SignalRConfiguration();
      config.url = UrlConstants.backofficeUrl;
      config.hubName = "ordersHub";
      config.logging = false;

      this.signalR.connect(config).then((res) => {
        this.portfolioConnection = res;

        this.portfolioConnection.invoke(
          "JoinGroup",
          this.selectedAccount.ExchangeCode
        );

        let method = new BroadcastEventListener<any>("UpdatePortfolio");
        this.portfolioConnection?.listen(method);
        method.subscribe((update) => {
          this.refetchClientInfo();
        });

        this.portfolioConnection?.errors.subscribe((res) => {
          this.initPortfolioSignalR();
        });
      });
    }
  }

  refetchClientInfo() {
    if (this.selectedAccount != null && this.selectedAccount.relationCode) {
      const currentTime = Date.now();
      const timeElapsed = currentTime - this.lastExecutionTime;

      if (timeElapsed < 5000) {
        return;
      }

      // Update the last execution time
      this.lastExecutionTime = currentTime;

      this.noChart = null;
      this.isProfileLoading = true;

      this.http
        .get(
          `${UrlConstants.backofficeUrl}/api/Client/GetClientInformation?relationCode=${this.selectedAccount.relationCode}`
        )
        .subscribe((res) => {
          this.isProfileLoading = false;
          this.userPortfolio = res as ClientData;

          this.companyName = this.userPortfolio.Profile.CompanyNameAr;

          this.Endorsement = `الساده شركة ${this.companyName} برجاء التكرم بفتح حد إئتمان للتداول في ذات الجلسة علي حسابي طرف شركتكم  وفي حالة التنفيذ و ظهور مديونية أتعهد أن يتم سداد كامل مديونية اليوم بالبيع أو بالإيداع و في حالة عدم التزامي بإغلاق المديونية قبل نهاية الجلسة بنصف ساعة أفوض الشركة ببيع أي أسهم موجودة بمحفظتي لسداد كامل المديونية وهذا إقرار مني بذلك`;

          if (
            this.ratedActiveBalance == 0 &&
            this.userPortfolio.Portfolio.RatedPortfolio == null
          )
            this.noChart = true;
          else if (
            this.ratedActiveBalance > 0 &&
            (!this.userPortfolio.Portfolio?.RatedPortfolio ||
              this.userPortfolio.Portfolio?.RatedPortfolio?.TotalMarketValue ==
                0)
          ) {
            this.purchaseStocks = 100;
            this.chartStocks = 0;
          } else if (
            this.ratedActiveBalance <= 0 &&
            this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue > 0
          ) {
            this.purchaseStocks = 0;
            this.chartStocks = 100;
          } else if (this.userPortfolio.Portfolio.RatedPortfolio != null) {
            this.chartStocks =
              (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue /
                (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue +
                  this.ratedActiveBalance)) *
              100;
            this.purchaseStocks =
              (this.ratedActiveBalance /
                (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue +
                  this.ratedActiveBalance)) *
              100;
          }
        });
    } else this.portfolioConnection.stop();
  }

  submitWithdraw(form: NgForm) {
    this.isSubmitting = true;
    this.newWithdraw.RelationCode = this.selectedAccount.relationCode;
    this.newWithdraw.BankId = form.form.value.depositBank?.BankID;
    this.newWithdraw.BankBrachId = form.form.value.bankBranch?.BranchID;
    this.newWithdraw.CurrencyId = form.form.value.CurrencyId?.CurrencyID;
    this.newWithdraw.Note = form.form.value.Note;
    const ibanOrAccount = form.form.value.ibanOrAccount?.trim();
    const ibanRegex = /^EG\d{2}[0-9A-Z]{25}$/i;
    const accountRegex = /^[0-9]{4,20}$/;

    if (ibanRegex.test(ibanOrAccount)) {
      this.newWithdraw.SwiftCode = ibanOrAccount.toUpperCase();
      this.newWithdraw.AccountNumber = null;
    } else if (accountRegex.test(ibanOrAccount)) {
      this.newWithdraw.AccountNumber = ibanOrAccount;
      this.newWithdraw.SwiftCode = null;
    } else {
      this.newWithdraw.SwiftCode = null;
      this.newWithdraw.AccountNumber = null;
    }
    const payload = { ...this.newWithdraw };
    delete payload.ibanOrAccount;

    const dialogRef = this.dialog
      .open(SummaryModalComponent, {
        data: {
          titleKey: "summary-banner-title",
          subtitleKey: 'summary-banner-text-Withdraw',
          details: [
            {
              icon: "mat-person",
              labelKey: "client",
              value:
                this.translate.currentLang === "en"
                  ? this.selectedAccount.clientNameEn
                  : this.selectedAccount.clientNameAr,
            },
            { icon: "💰", labelKey: "amount", value: form.form.value.Amount },
            { icon: "📆", labelKey: "date", value: this.today },
            {
              icon: "💵",
              labelKey: "currency",
              value:
                this.translate.currentLang === "en"
                  ? form.form.value.CurrencyId?.AbbreviationE
                  : form.form.value.CurrencyId?.AbbreviationA,
            },
            {
              icon: "🏢",
              labelKey: "Withdraw_Bank",
              value:
                this.translate.currentLang === "en"
                  ? form.form.value.depositBank?.BankNameE
                  : form.form.value.depositBank?.BankNameA,
            },
            {
              icon: "🏦",
              labelKey: "branch",
              value:
                this.translate.currentLang === "en"
                  ? form.form.value.bankBranch?.BranchNameE
                  : form.form.value.bankBranch?.BranchNameA ,
            },
            {
              icon: "mat-credit_card",
              labelKey: "IBAN",
              value: payload.SwiftCode,
            },
            {
              icon: "mat-credit_card",
              labelKey: "account-number",
              value: payload.AccountNumber,
            },
          ],
        },
        direction: this.translate.currentLang === "ar" ? "rtl" : "ltr",
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.isSubmitting = true;
          this.http
            .post(
              UrlConstants.backofficeUrl +
                "/api/OnlineTrading/PostReceivableRequest",
              payload
            )
            .subscribe(
              (res) => {
                this.isSubmitting = false;
                if (res["isValid"]) {
                  if (res) this.submitStatus = res;
                  form.resetForm();

                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: this.translate.instant("succes-msg"),
                    showConfirmButton: false,
                    timer: 4500,
                  }).then(() => {
                    this.router.navigate(["/requests-analysis/requests-table"], { queryParams: { reload: true } });
                  });
                } else {
                  Swal.fire({
                    position: "center",
                    icon: "error",
                    title: res["fieldValidations"][0],
                    showConfirmButton: false,
                    timer: 4500,
                  });
                  this.router.navigate(["/requests-analysis/requests-table"], { queryParams: { reload: true } });
                }
              },
              (err) => {
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: this.translate.instant("error-msg"),
                  showConfirmButton: false,
                  timer: 4500,
                });
              }
            );
        } else {
          this.isSubmitting = false;
        }
      });
  }
detectIbanOrAccount() {
  const input = this.newWithdraw.ibanOrAccount?.trim();

  if (!input) {
    this.newWithdraw.SwiftCode = null;
    this.newWithdraw.AccountNumber = null;
    this.isIban = null;
    return;
  }

  // Egyptian IBAN: exactly 29 chars — EG + 2 check digits + 25 alphanumeric
  const ibanRegex = /^EG\d{2}[0-9A-Z]{25}$/i;
  const accountRegex = /^[0-9]{4,20}$/;

  if (ibanRegex.test(input)) {
    this.newWithdraw.SwiftCode = input.toUpperCase();
    this.newWithdraw.AccountNumber = null;
    this.isIban = true;

  } else if (accountRegex.test(input)) {
    this.newWithdraw.AccountNumber = input;
    this.newWithdraw.SwiftCode = null;
    this.isIban = false;

  } else {
    this.newWithdraw.SwiftCode = null;
    this.newWithdraw.AccountNumber = null;
    this.isIban = null;
    // ✅ FIX: Explicitly mark form field as invalid to block submission
    this.withdrawForm.form.get('ibanOrAccount')?.setErrors({ invalidFormat: true });
  }
}
}
